import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { ReactionsByType } from '../../types/reactions';
import { reactionsService } from '../../services/reactionsService';

interface ReactionsListProps {
  goodThingId: string;
  className?: string;
}

export const ReactionsList: React.FC<ReactionsListProps> = React.memo(({ goodThingId, className = '' }) => {
  const [reactions, setReactions] = useState<ReactionsByType | null>(null);

  useEffect(() => {
    // Load initial reactions
    const loadReactions = async () => {
      const reactions = await reactionsService.getReactionsByGoodThing(goodThingId);
      setReactions(reactions);
    };

    loadReactions();

    // Subscribe to reaction updates
    const unsubscribe = reactionsService.subscribeToReactions(goodThingId, (updatedReactions) => {
      setReactions(updatedReactions);
    });

    return () => unsubscribe();
  }, [goodThingId]);

  if (!reactions || Object.entries(reactions).length === 0) {
    return null;
  }

  return (
    <div className={`reactions-list ${className}`}>
      {Object.entries(reactions).map(([type, data]) => (
        <TooltipProvider key={type}>
          <Tooltip>
            <TooltipTrigger asChild>
              <motion.div
                className="reaction-count"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0 }}
              >
                <span>{type}</span>
              </motion.div>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-sm">
                {data.users.map((user) => user.displayName).join(', ')}
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ))}
    </div>
  );
});

ReactionsList.displayName = 'ReactionsList';